export default "/images/checkCircleIcon.svg?a03ca9011b14f277191e7d843daa0642";